import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { api } from "@/lib/api";

const TAB = { regions: "Most regions", grimfang: "Fastest Grimfang", vexa: "Fastest Vexa", nocturne: "Fastest Nocturne" };
const MEDAL = ["text-amber-300", "text-slate-200", "text-orange-300"];

export default function HallOfFame() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/hall-of-fame").then(({ data }) => setD(data)).catch(() => setD({ weeks: [], legends: [] })); }, []);
  if (!d) return <p className="text-slate-500">Opening the hall…</p>;
  if (!d.weeks.length) return <p data-testid="hof-empty" className="text-slate-500 py-10 text-center">No champions crowned yet. The first crowns are handed out on Monday.</p>;

  return (
    <div className="space-y-10" data-testid="hall-of-fame">
      {d.legends.length > 0 && (
        <section>
          <h2 className="font-display text-2xl text-amber-100 mb-4">Legends of the pack</h2>
          <div className="flex flex-wrap gap-4">
            {d.legends.map((l, i) => (
              <div key={i} data-testid={`hof-legend-${i + 1}`} className="flex items-center gap-3 pr-4 rounded-full border border-amber-400/40 bg-amber-500/5">
                <img src={l.portrait} alt={l.wolf_name} className="w-12 h-12 rounded-full object-cover border border-amber-400/70" />
                <div><p className="font-display text-white">{l.wolf_name}</p><p className="text-[11px] text-amber-300">{l.titles} weekly title{l.titles > 1 ? "s" : ""}</p></div>
              </div>
            ))}
          </div>
        </section>
      )}
      {d.weeks.map((w) => (
        <section key={w.week} data-testid={`hof-week-${w.week}`}>
          <p className="font-mono-game text-xs text-slate-400 mb-3">WEEK {w.week}</p>
          <div className="grid sm:grid-cols-2 gap-3">
            {Object.keys(TAB).filter((t) => w.champions.some((c) => c.tab === t)).map((t) => (
              <div key={t} className="rounded-2xl border border-slate-800 bg-[#081820]/70 p-4">
                <p className="text-sm text-slate-300 mb-3">{TAB[t]}</p>
                <div className="space-y-2">
                  {w.champions.filter((c) => c.tab === t).map((c) => (
                    <div key={c.rank} className="flex items-center gap-3">
                      <Crown className={`w-4 h-4 ${MEDAL[c.rank - 1]}`} />
                      <img src={c.portrait} alt="" className="w-9 h-9 rounded-lg object-cover" />
                      <span className="flex-1 truncate text-white">{c.wolf_name}{t === "regions" && c.rank === 1 && <span data-testid={`hof-mwp-${w.week}`} className="ml-2 px-1.5 py-0.5 rounded bg-amber-400 text-black text-[9px] font-bold tracking-wider align-middle">MWP</span>}{c.character && <span className="text-xs text-slate-500"> · {c.character}</span>}</span>
                      <span className="font-mono-game text-xs text-amber-200">+{c.credits}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
